import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId')({
  beforeLoad: () => getTitleContextSlice('Severity Audit Logs'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
